import { ListView } from 'src/components/templates';
import styled from 'styled-components';

export const StyledListView = styled(ListView)`
  .title {
    align-self: unset;
    padding: 0.5rem 0;
    flex-basis: 5%;
  }
`;
